module.exports = __webpack_public_path__ + "static/media/warning_delay.741b3c8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/warning_delay.svg
// module id = 263
// module chunks = 0